import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import hasRESTClient from '../../hocs/has-rest-client';
import withUserInfo from '../../hocs/has-user-info';
import CampaignReportCard from '../../components/campaign-report-card';

const delay = ms => new Promise((resolve, reject) => setTimeout(resolve, ms));

const reportsMonths = ['AUGUST'];

const boxStyle = {
  paddingTop: 19,
  paddingBottom: 19,
};

class AbbottLyonDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      augustReports: [],
      augustIsLoading: false,
      augustIsReloading: false,
      groupView: true,
    };
    const { buildRESTClient } = this.props;
    this.reportImportClient = buildRESTClient({
      baseURL: process.env.REACT_APP_SHARE_API_URL || '',
      hasToken: false,
      timeout: 100000,
    });
  }


toggleGroupView = () => {
  this.setState(prev => ({ groupView: !prev.groupView }));
}
groupReports = reports => {
  const groupped = _.groupBy(reports, 'name');
  return _.reduce(_.values(groupped), (acc, group) => {
    const result = {};
    const first = group[0];
    _.forEach(_.keys(first), key => {
      result[key] = _.isNumber(first[key]) ? _.sumBy(group, key) : first[key];
    });
    acc.push(result);
    return acc;
  }, []);
}
  fetchReportForMonth = async (month, reloading = false) => {
    const loadingStateKey = reloading ? `${_.toLower(month)}IsReloading` : `${_.toLower(month)}IsLoading`;
    this.setState({
      [loadingStateKey]: true,
    });
    const { userInfo: { organisationId } } = this.props;
    const params = reloading ? { clearCache: true } : {};
    await this.reportImportClient.get(`/organisation/${organisationId}/report/${month}`, { params }).then(response => {
      const reports = _.get(response, 'data.data.data.reports', []);

      const groupedReports = this.groupReports(reports);
      this.setState({
        [`${_.toLower(month)}Reports`]: _.sortBy(reports, 'name'),
        [`${_.toLower(month)}ReportsGrouped`]: _.sortBy(groupedReports, 'name'),
        [loadingStateKey]: false,
      });
    }).catch(err => {
      this.setState({
        [`${_.toLower(month)}Reports`]: [],
        [`${_.toLower(month)}ReportsGrouped`]: [],
        [loadingStateKey]: false,
      });
    });
  }
  fetchReports = async () => {
    this.setState({
      augustIsLoading: true,
    });
    // eslint-disable-next-line no-restricted-syntax
    for (const month of reportsMonths) {
      // eslint-disable-next-line no-await-in-loop
      await this.fetchReportForMonth(month);
      delay(500);
    }
  }

  componentDidMount() {
    this.fetchReports();
  }


  render() {
    const {
      augustReports,
      augustReportsGrouped,
      augustIsLoading,
      augustIsReloading,
      groupView,
    } = this.state;

    return (
      <div className="page">
        <div className="influencer-context-bar" style={boxStyle}>
          <div className="spacer small" />
          <div className="flex">
            <div className="item">
              <h1>Dashboard</h1>
            </div>
            <div className="space" />
          </div>
          <div className="flex" >
            <div className="item">
              <h3 className="light">Abbott Lyon</h3>
            </div>
            <div className="item">
              <div className="horizontal-spacer" />
            </div>
            <div className="space" />
          </div>
        </div>
        <div className="page-content">
          <div>
            <CampaignReportCard
              campaigns={groupView ? augustReportsGrouped : augustReports}
              title="August"
              month="AUGUST"
              isLoading={augustIsLoading}
              onReload={this.fetchReportForMonth}
              isReloading={augustIsReloading}
              onGroupViewToggle={this.toggleGroupView}
            />
          </div>
        </div>
      </div>
    );
  }
}

AbbottLyonDashboard.propTypes = {
  buildRESTClient: PropTypes.func.isRequired,
};
export default compose(
  hasRESTClient,
  withUserInfo,
)(AbbottLyonDashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/abbott-lyon-dashboard/index.js
 **/